import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// HANDLE CSS LOCAL
import "@/assets/css/main.css";
// HANDLE BOOTSTRAP V5.3.3
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
// HANDLE FONTAWESOME ICON V6
import "@/assets/fontawesome5/css/all.css";
// HANDLE AXIOS
import "@/services/AxiosService";
// HANDLE HELPER
import "@/utils/Helper";

Vue.config.productionTip = false;

if (!localStorage.getItem("token")) {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
} else {
  store
    .dispatch("Auth/readUserByToken")
    .then(() => {
      new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount("#app");
    })
    .catch((err) => {
      console.log(err);
    });
}
